import { useParams } from 'react-router'
import useGlobal from '@/hooks/useGlobal'

export interface LoyaltyContext {
  orgId: string
  schemeId: string
  serial?: string
  isVenueContext: boolean
  basePath: string
  breadcrumbRoot: {
    label: string
    path: string
  }
  getServicePath: (service: string) => string
  getSchemePath: (schemeId?: string) => string
  getLoyaltyListPath: () => string
}

export function useLoyaltyContext(): LoyaltyContext {
  const { orgId: globalOrgId } = useGlobal()
  const params = useParams<{
    org_id?: string
    id?: string
    loyalty_scheme_id?: string
    serial?: string
  }>()

  const orgId = params.org_id ?? globalOrgId ?? ''
  const schemeId = params.id ?? params.loyalty_scheme_id ?? ''
  const serial = params.serial
  const isVenueContext = Boolean(serial)

  const basePath = isVenueContext
    ? `/${orgId}/venues/${serial}/loyalty/${schemeId}`
    : `/${orgId}/loyalty/${schemeId}`

  const breadcrumbRoot = isVenueContext
    ? { label: 'Venue', path: `/${orgId}/venues/${serial}` }
    : { label: 'Loyalty', path: `/${orgId}/loyalty` }

  const getServicePath = (service: string) => `${basePath}/${service}`

  const getSchemePath = (newSchemeId?: string) => {
    const targetSchemeId = newSchemeId ?? schemeId
    return isVenueContext
      ? `/${orgId}/venues/${serial}/loyalty/${targetSchemeId}`
      : `/${orgId}/loyalty/${targetSchemeId}`
  }

  const getLoyaltyListPath = () => {
    return isVenueContext ? `/${orgId}/venues/${serial}` : `/${orgId}/loyalty`
  }

  return {
    orgId,
    schemeId,
    serial,
    isVenueContext,
    basePath,
    breadcrumbRoot,
    getServicePath,
    getSchemePath,
    getLoyaltyListPath,
  }
}
